import IsLoading from "@/components/layouts/IsLoading";
import TrialContext from "@/contexts/data/TrialContext";
import useTrialStatuses from "@/hooks/data/useTrialStatuses";
import { Alert, AlertTitle, Box, Chip, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableHead, TableRow, Theme, Tooltip, TooltipProps, Typography, darken, lighten, styled, tooltipClasses, useTheme } from "@mui/material";
import { FC, Fragment, ReactNode, useCallback, useContext, useMemo } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faCommentAlt, faCommentCaptions, faExclamationCircle, faFileCheck, faFileMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons";
import { green, grey, red, yellow } from "@mui/material/colors";
import StatusList from "@/components/lists/status/StatusList";
import useInstitutions from "@/hooks/data/useInstitutions";
import useInstitutionStatuses from "@/hooks/data/useInstitutionStatuses";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import Show from "@/components/layouts/Show";
import { CoordinatingGroup, Institution, MasterGroup, UpdateStatusEvent } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import { DefaultSortableFields, IStatusListSortable } from "@/components/lists/status/StatusListSort";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import MasterGroupsContext from "@/contexts/data/MasterGroupsContext";
import CoordinatingGroupsContext from "@/contexts/data/CoordinatingGroupsContext";
import InstitutionStatusList from "@/components/lists/status/InstitutionStatusList";


const Institutions: FC = () => {
    const theme = useTheme();
    const { data: trial } = useContext(TrialContext);
    const { data: institutions } = useContext(InstitutionsContext);
    const { idMap: institutionStatuses, loading: institutionStatusesLoading, validating: institutionStatusesValidating, refresh: institutionStatusesRefresh } = useInstitutionStatuses(trial?.id);

    const updateStatuses = useCallback(async (event: UpdateStatusEvent) => {
        if (event.trialId == trial?.id) {
            await institutionStatusesRefresh()
        }
    }, [institutionStatusesRefresh, trial]);

    const {processing, queueUpdate, error} = useStatusUpdate(
        updateStatuses,
        updateStatuses
    );

    const queueStatusUpdate = useCallback(async (item: Institution) => {
        await queueUpdate({ institutionId: item.id });
        await institutionStatusesRefresh();
    }, [queueUpdate, institutionStatusesRefresh])
    
    const loading = institutionStatusesLoading;
    const validating = institutionStatusesValidating || processing;

    return (
        <>
            <IsLoading name="institutions-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Institutions
                </Typography>
                <InstitutionStatusList 
                    data={institutions}
                    statuses={institutionStatuses}
                    queueUpdate={queueStatusUpdate}
                />
            </Show>
        </>
    )
};

export default Institutions;